import { type CoInvestIoiOutcome } from "@vega-core/utils/posthog/eventCatalogue";

import { captureEvent } from "./captureEvent";

type DealRef = {
  dealOpportunityId: string;
  dealId: string | undefined;
};

export const trackCoInvestTeaserViewed = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_teaser_viewed", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestNdaOpened = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_nda_opened", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestNdaDismissed = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_nda_dismissed", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestNdaDownloaded = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_nda_downloaded", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestDataRoomAccessed = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_data_room_accessed", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestNdaSignAttempted = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_nda_sign_attempted", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestRejectModalOpened = ({
  dealOpportunityId,
}: {
  dealOpportunityId: string;
}): void =>
  captureEvent("coinvest_reject_modal_opened", {
    deal_opportunity_id: dealOpportunityId,
  });

export const trackCoInvestDealRejectAttempted = ({
  dealOpportunityId,
}: {
  dealOpportunityId: string;
}): void =>
  captureEvent("coinvest_deal_reject_attempted", {
    deal_opportunity_id: dealOpportunityId,
  });

export const trackCoInvestIoiSubmitted = ({
  dealOpportunityId,
  dealId,
  outcome,
}: DealRef & { outcome: CoInvestIoiOutcome }): void =>
  captureEvent("coinvest_ioi_submitted", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
    outcome,
  });

export const trackCoInvestCommitmentAttempted = ({
  dealOpportunityId,
}: {
  dealOpportunityId: string;
}): void =>
  captureEvent("coinvest_commitment_attempted", {
    deal_opportunity_id: dealOpportunityId,
  });

export const trackCoInvestDealOpportunityViewed = ({
  dealOpportunityId,
  dealId,
}: DealRef): void =>
  captureEvent("coinvest_deal_opportunity_viewed", {
    deal_opportunity_id: dealOpportunityId,
    deal_id: dealId,
  });

export const trackCoInvestDealTabViewed = ({
  dealOpportunityId,
  tab,
}: {
  dealOpportunityId: string;
  tab: string;
}): void =>
  captureEvent("coinvest_deal_tab_viewed", {
    deal_opportunity_id: dealOpportunityId,
    tab,
  });

export const trackCoInvestDocumentDownloaded = ({
  dealOpportunityId,
  documentId,
}: {
  dealOpportunityId: string;
  documentId: string;
}): void =>
  captureEvent("coinvest_document_downloaded", {
    deal_opportunity_id: dealOpportunityId,
    document_id: documentId,
  });

export const trackCoInvestQuestionAsked = ({
  dealOpportunityId,
}: {
  dealOpportunityId: string;
}): void =>
  captureEvent("coinvest_question_asked", {
    deal_opportunity_id: dealOpportunityId,
  });

export const trackCoInvestDealsFiltered = ({
  filter,
}: {
  filter: string;
}): void => captureEvent("coinvest_deals_filtered", { filter });
